/*LIBRARY*/
import React, { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SINI_POLYGON_CONFIG from "./SINI_POLYGON_CONFIG";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/
import ICON_BACK from "../../Assets/jsx/ICON_BACK";

/*FUNCTION*/
import calculate_rdtr from "../../App/validation/calculate_rdtr";

/*DATA*/
import colors_rdtr from "../../Data/colors_rdtr.json";
import dict from "../../Data/dict.json";

/*CONST*/

class SINI_RDTR_FULL extends Component {
  state = { anchor: null, modal_layer_config: false };

  componentWillUnmount() {
    this.props.set_value_sini({
      key: "rdtr_input_OBJECTID",
      value: "",
    });
  }

  on_calc = () => {
    const {
      rdtr_calc_mode,
      rdtr_input_area_m2,
      rdtr_input_KDB,
      rdtr_input_KLB,
      rdtr_input_KDH,
    } = this.props.sini;

    if (rdtr_calc_mode === "one_mode") {
      const result = calculate_rdtr({
        KDB: rdtr_input_KDB,
        KLB: rdtr_input_KLB,
        KDH: rdtr_input_KDH,
        rdtr_input_area_m2,
      });
      const {
        rdtr_result_LDB,
        rdtr_result_LLB,
        rdtr_result_LRH,
        rdtr_result_JLB,
      } = result;

      this.props.set_value_sini({
        key: "rdtr_result_LDB",
        value: rdtr_result_LDB,
      });
      this.props.set_value_sini({
        key: "rdtr_result_LLB",
        value: rdtr_result_LLB,
      });
      this.props.set_value_sini({
        key: "rdtr_result_JLB",
        value: rdtr_result_JLB,
      });
      this.props.set_value_sini({
        key: "rdtr_result_LRH",
        value: rdtr_result_LRH,
      });
      this.props.set_value_sini({
        key: "rdtr_area_changes",
        value: false,
      });
    }
  };

  on_change = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.props.set_value_sini({
      key: name,
      value: value,
    });
    if (name === "rdtr_input_area_m2") {
      this.props.set_value_sini({
        key: "rdtr_area_changes",
        value: true,
      });
    }
  };

  toggle_layer_config = (e) => {
    this.setState({ modal_layer_config: !this.state.modal_layer_config });
    if (e) {
      this.setState({ anchor: e.currentTarget });
    }
  };

  toggle_sini_map_show = (item) => {
    let { sini_map_show } = this.props.sini;
    if (sini_map_show.includes(item)) {
      sini_map_show = sini_map_show.filter((element) => element !== item);
    } else {
      sini_map_show.push(item);
    }
    this.props.set_value_sini({
      key: "sini_map_show",
      value: sini_map_show,
    });
  };

  on_set_sini_menu_active = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["poi", "isochrone"],
    });
    this.props.set_value_sini({
      key: "rdtr_input_OBJECTID",
      value: "",
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { modal_layer_config, anchor } = this.state;

    //global props
    const {
      sini_v2_list,
      request_id_active,
      ai_parent_detail_list,
      rdtr_calc_mode,
      rdtr_input_area_m2,
      rdtr_input_NAMOBJ,
      rdtr_input_KDB,
      rdtr_input_KLB,
      rdtr_input_KDH,
      rdtr_area_changes,
      rdtr_result_LDB,
      rdtr_result_LLB,
      rdtr_result_JLB,
      rdtr_result_LRH,
    } = this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const is_loading_rdtr = loading_item_array.includes("rdtr");

    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );
    const rdtr_one = sini_object?.rdtr_one;

    let content;

    if (is_loading_rdtr || rdtr_one !== undefined) {
      const rdtr_value = rdtr_one?.properties?.["NAMZON_1"];
      const is_rdtr_empty = rdtr_value === undefined;
      let rdtr_content;
      if (is_loading_rdtr) {
        rdtr_content = (
          <>
            <p className="text_small">{dict?.["Loading"]?.[language]}...</p>
            <br />
          </>
        );
      } else if (!is_rdtr_empty) {
        rdtr_content = (
          <>
            <main className="container_light margin_bottom">
              {rdtr_calc_mode !== "" && (
                <>
                  <section className="margin_bottom">
                    <p className="text_medium">
                      {dict?.["Step 1: Select a polygon"]?.[language]}
                    </p>
                    <main className="container_light background_white outline_black">
                      {rdtr_calc_mode !== "" ? (
                        <section>
                          {
                            dict?.[
                              "Select an area by clicking on the polygon on the map."
                            ]?.[language]
                          }
                        </section>
                      ) : (
                        <section>
                          {
                            dict?.["Select the calculation mode first"]?.[
                              language
                            ]
                          }
                        </section>
                      )}
                    </main>
                  </section>
                  {!!rdtr_input_NAMOBJ && (
                    <>
                      <section className="margin_bottom">
                        <p className="text_medium">
                          {dict?.["Step 2: Enter the land area"]?.[language]}
                        </p>
                        <div className="container_light background_white outline_black">
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  <input
                                    name="rdtr_input_area_m2"
                                    value={rdtr_input_area_m2}
                                    onChange={this.on_change}
                                    type="number"
                                    className="margin_bottom"
                                  />
                                </td>
                                <td>
                                  <p className="text_medium">
                                    meter<sup>2</sup>
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <button
                            className="button_small background_black"
                            onClick={this.on_calc}
                          >
                            {dict?.["Recalculate"]?.[language]}
                          </button>
                        </div>
                      </section>
                      {!rdtr_area_changes && (
                        <section className="margin_bottom">
                          <p className="text_medium">Hasil kalkulator</p>
                          <main className="container_light background_white outline_black">
                            <table
                              className="table full_width margin_bottom"
                              style={{ tableLayout: "fixed" }}
                            >
                              <tbody>
                                <tr>
                                  <td colSpan={3} className="text_bold">
                                    Input
                                  </td>
                                </tr>

                                <tr>
                                  <td>{dict?.["Object name"]?.[language]}</td>
                                  <td colSpan={2}>{rdtr_input_NAMOBJ}</td>
                                </tr>
                                <tr>
                                  <td>KDB</td>
                                  <td>{rdtr_input_KDB}</td>
                                  <td>%</td>
                                </tr>
                                <tr>
                                  <td>KLB</td>
                                  <td>{rdtr_input_KLB}</td>
                                  <td>desimal</td>
                                </tr>
                                <tr>
                                  <td>KDH</td>
                                  <td>{rdtr_input_KDH}</td>
                                  <td>%</td>
                                </tr>
                                <tr>
                                  <td>{dict?.["Input area"]?.[language]}</td>
                                  <td>{rdtr_input_area_m2}</td>
                                  <td>
                                    meter <sup>2</sup>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={3} className="text_bold">
                                    Output
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {
                                      dict?.["Base area of the building"]?.[
                                        language
                                      ]
                                    }
                                    <br />
                                    (LDB)
                                  </td>
                                  <td>
                                    {new Intl.NumberFormat("id-ID", {
                                      style: "decimal",
                                    }).format(rdtr_result_LDB)}
                                  </td>
                                  <td>
                                    meter <sup>2</sup>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {dict?.["Building floor area"]?.[language]}
                                    <br />
                                    (LLB)
                                  </td>
                                  <td>
                                    {new Intl.NumberFormat("id-ID", {
                                      style: "decimal",
                                    }).format(rdtr_result_LLB)}
                                  </td>
                                  <td>
                                    meter <sup>2</sup>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {
                                      dict?.[
                                        "Number of floors of the building"
                                      ]?.[language]
                                    }
                                    <br />
                                    (JLB)
                                  </td>
                                  <td>
                                    {new Intl.NumberFormat("id-ID", {
                                      style: "decimal",
                                    }).format(rdtr_result_JLB)}
                                  </td>
                                  <td>{dict?.["story"]?.[language]}</td>
                                </tr>
                                <tr>
                                  <td>
                                    {dict?.["Green space area"]?.[language]}
                                    <br />
                                    (LRH)
                                  </td>
                                  <td>
                                    {new Intl.NumberFormat("id-ID", {
                                      style: "decimal",
                                    }).format(rdtr_result_LRH)}
                                  </td>
                                  <td>
                                    meter <sup>2</sup>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </main>
                        </section>
                      )}
                    </>
                  )}
                </>
              )}
            </main>
          </>
        );
      } else {
        rdtr_content = (
          <section className="margin_bottom">
            <p className="text_small">{dict?.["No data"]?.[language]}</p>
          </section>
        );
      }
      content = <main>{rdtr_content}</main>;
    }

    const modal_layer_config_content = (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_layer_config}
        onClose={this.toggle_layer_config}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div
          style={{
            width: "250px",
          }}
        >
          <SINI_POLYGON_CONFIG />
        </div>
      </FLOAT_MENU>
    );

    const legend_content = (
      <main className="container_light">
        <p className="text_bold margin_bottom">
          {dict?.["Legend"]?.[language]}
        </p>
        <button
          className="button_small margin_bottom background_black"
          onClick={this.toggle_layer_config}
        >
          {dict?.["Edit info on map"]?.[language]}
        </button>
        <br />
        <table className="text_small">
          <tbody>
            {colors_rdtr.map((item, idx) => {
              return (
                <tr key={idx}>
                  <td>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "5px",
                        backgroundColor: item.color,
                      }}
                    />
                  </td>
                  <td>{item.name}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    );
    return (
      <main className="sini_full_parent">
        {modal_layer_config_content}
        {!this.props.no_back_button && (
          <section className="sini_full_header">
            <table>
              <tbody>
                <tr>
                  <td
                    style={{ width: "30px" }}
                    onClick={this.on_set_sini_menu_active}
                  >
                    <ICON_BACK />
                  </td>
                  <td className="text_left">
                    <div className="badge background_green margin_bottom">
                      {dict?.["RDTR Calculator"]?.[language]}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        )}

        <br />
        <section className="sini_full_scroll_area">
          {content}
          {legend_content}
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, { set_value_sini })(SINI_RDTR_FULL);
